import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './QuizProgressBarV2.css';

const cx = classnames.bind(styles);

function QuizProgressBarV2({ currentSlideIndex, totalSlides }) {
    return (
        <div className={styles.root}>
            {Array.from({ length: totalSlides }, (_, index) => (
                <div
                    key={index}
                    className={cx('segment', { filled: index < currentSlideIndex })}
                />
            ))}
        </div>
    );
}

QuizProgressBarV2.propTypes = {
    currentSlideIndex: PropTypes.number,
    totalSlides: PropTypes.number
};

QuizProgressBarV2.defaultProps = {
    currentSlideIndex: 0,
    totalSlides: 0
};

export {
    QuizProgressBarV2
};
